import { ShowcasePage } from '../r5/ShowcasePage';

export function CrdShowcasePage() {
  return <ShowcasePage />;
}
